// 🧭 FRASES DO DIA da Vitrine (item 336): filósofos, pensadores e cinema
// (pedido dele, 12/10 noite: "tirar as bíblicas por enquanto"). Uma por dia,
// a mesma para todo mundo (escolha pelo dia do ano). Para trocar, edite
// aqui; `fonte` aparece pequeno abaixo da frase.
export const FRASES = [
  {
    texto:
      'Não é porque as coisas são difíceis que não ousamos; é porque não ousamos que elas são difíceis.',
    fonte: 'Sêneca',
  },
  {
    texto:
      'Você tem poder sobre a sua mente, não sobre os acontecimentos. Perceba isso e encontrará força.',
    fonte: 'Marco Aurélio',
  },
  { texto: 'Não explique a sua filosofia. Incorpore-a.', fonte: 'Epicteto' },
  { texto: 'Enquanto esperamos pela vida, a vida passa.', fonte: 'Sêneca' },
  {
    texto:
      'A felicidade da sua vida depende da qualidade dos seus pensamentos.',
    fonte: 'Marco Aurélio',
  },
  {
    texto: 'Não é o que acontece com você, mas como você reage, que importa.',
    fonte: 'Epicteto',
  },
  {
    texto:
      'A sorte é o que acontece quando a preparação encontra a oportunidade.',
    fonte: 'Sêneca',
  },
  { texto: 'Limite-se ao presente.', fonte: 'Marco Aurélio' },
  {
    texto:
      'Primeiro diga a si mesmo o que você seria; depois faça o que tem de fazer.',
    fonte: 'Epicteto',
  },
  {
    texto: 'Não é a quantidade de vida que importa, mas a qualidade.',
    fonte: 'Sêneca',
  },
  {
    texto: 'Se não for certo, não o faça; se não for verdade, não o diga.',
    fonte: 'Marco Aurélio',
  },
  {
    texto:
      'A riqueza não consiste em ter grandes posses, mas em ter poucas necessidades.',
    fonte: 'Epicteto',
  },
  {
    texto:
      'Levante-se de manhã e pense no privilégio que é estar vivo: respirar, pensar, aproveitar, amar.',
    fonte: 'Marco Aurélio',
  },
  { texto: 'Ninguém é livre se não é senhor de si mesmo.', fonte: 'Epicteto' },
  {
    texto:
      'Tudo o que ouvimos é uma opinião, não um fato. Tudo o que vemos é uma perspectiva, não a verdade.',
    fonte: 'Marco Aurélio',
  },
  {
    texto:
      'Dificuldades fortalecem a mente, como o trabalho fortalece o corpo.',
    fonte: 'Sêneca',
  },
  { texto: 'A excelência não é um ato, mas um hábito.', fonte: 'Aristóteles' },
  {
    texto:
      'Não desperdice o que resta da vida com pensamentos sobre os outros.',
    fonte: 'Marco Aurélio',
  },
  {
    texto: 'Se quiser melhorar, aceite parecer tolo em algumas coisas.',
    fonte: 'Epicteto',
  },
  {
    texto: 'Não espere por Platão para construir a sua cidade.',
    fonte: 'Marco Aurélio',
  },
  {
    texto: 'Uma vida sem reflexão não vale a pena ser vivida.',
    fonte: 'Sócrates',
  },
  { texto: 'Conhece-te a ti mesmo.', fonte: 'Sócrates' },
  {
    texto: 'A paciência é amarga, mas o seu fruto é doce.',
    fonte: 'Aristóteles',
  },
  {
    texto:
      'Escolha um trabalho que você ame e não terá de trabalhar um dia sequer.',
    fonte: 'Confúcio',
  },
  {
    texto: 'Não importa a lentidão com que você avance, desde que não pare.',
    fonte: 'Confúcio',
  },
  {
    texto: 'Uma viagem de mil milhas começa com um único passo.',
    fonte: 'Lao Tsé',
  },
  {
    texto:
      'A coragem é a primeira das qualidades humanas, porque garante todas as outras.',
    fonte: 'Aristóteles',
  },
  {
    texto: 'Aquele que tem um porquê para viver suporta quase qualquer como.',
    fonte: 'Friedrich Nietzsche',
  },
  { texto: 'O homem é aquilo que faz repetidamente.', fonte: 'Aristóteles' },
  {
    texto: 'Age de tal modo que a tua ação possa valer como regra para todos.',
    fonte: 'Immanuel Kant',
  },
  { texto: 'A medida do amor é amar sem medida.', fonte: 'Santo Agostinho' },
  {
    texto:
      'Entre o estímulo e a resposta há um espaço; nesse espaço está a nossa liberdade.',
    fonte: 'Viktor Frankl',
  },
  { texto: 'Nada é mais poderoso do que o hábito.', fonte: 'Ovídio' },
  {
    texto: 'O homem feliz é aquele que confia na sua própria conduta.',
    fonte: 'Platão',
  },
  { texto: 'Começar já é metade de toda ação.', fonte: 'Pitágoras' },
  { texto: 'Penso, logo existo.', fonte: 'René Descartes' },
  {
    texto:
      'A vida só pode ser compreendida olhando para trás, mas só pode ser vivida olhando para a frente.',
    fonte: 'Søren Kierkegaard',
  },
  {
    texto: 'Só sei que nada sei.',
    fonte: 'Sócrates',
  },
  {
    texto: 'O que não me mata me fortalece.',
    fonte: 'Friedrich Nietzsche',
  },
  {
    texto:
      'A mente que se abre a uma nova ideia jamais volta ao tamanho original.',
    fonte: 'Albert Einstein',
  },
  {
    texto: 'A imaginação é mais importante que o conhecimento.',
    fonte: 'Albert Einstein',
  },
  {
    texto: 'Seja a mudança que você quer ver no mundo.',
    fonte: 'Mahatma Gandhi',
  },
  {
    texto: 'Tenho a impressão de que o sucesso vem para quem faz o que gosta.',
    fonte: 'Steve Jobs',
  },
  {
    texto: 'A simplicidade é a sofisticação máxima.',
    fonte: 'Leonardo da Vinci',
  },
  {
    texto: 'O futuro pertence àqueles que acreditam na beleza dos seus sonhos.',
    fonte: 'Eleanor Roosevelt',
  },
  {
    texto: 'Na vida, não existe nada a temer, apenas a ser compreendido.',
    fonte: 'Marie Curie',
  },
  {
    texto: 'Nunca é tarde demais para ser o que você poderia ter sido.',
    fonte: 'George Eliot',
  },
  {
    texto: 'O que fazemos repetidamente é o que somos.',
    fonte: 'Will Durant',
  },
  {
    texto: 'Faça ou não faça. Tentativa não há.',
    fonte: 'Mestre Yoda, O Império Contra-Ataca',
  },
  {
    texto:
      'Carpe diem. Aproveitem o dia, rapazes. Façam das suas vidas algo extraordinário.',
    fonte: 'Sociedade dos Poetas Mortos',
  },
  {
    texto: 'Não deixe ninguém dizer que você não pode fazer uma coisa.',
    fonte: 'À Procura da Felicidade',
  },
  {
    texto:
      'A vida é como uma caixa de chocolates: você nunca sabe o que vai encontrar.',
    fonte: 'Forrest Gump',
  },
  {
    texto:
      'Não importa o quanto você bate, mas o quanto aguenta apanhar e continuar.',
    fonte: 'Rocky Balboa',
  },
  {
    texto: 'Por que caímos? Para aprender a nos levantar.',
    fonte: 'Batman Begins',
  },
  {
    texto: 'O passado pode doer. Mas você pode fugir dele ou aprender com ele.',
    fonte: 'O Rei Leão',
  },
  {
    texto: 'Grandes poderes trazem grandes responsabilidades.',
    fonte: 'Homem-Aranha',
  },
  {
    texto: 'Só temos de decidir o que fazer com o tempo que nos é dado.',
    fonte: 'O Senhor dos Anéis',
  },
  {
    texto: 'Continue a nadar.',
    fonte: 'Dory, Procurando Nemo',
  },
  {
    texto:
      'Às vezes são as pessoas de quem ninguém espera nada que fazem as coisas que ninguém imagina.',
    fonte: 'O Jogo da Imitação',
  },
  {
    texto:
      'A esperança é uma coisa boa, talvez a melhor das coisas. E as coisas boas nunca morrem.',
    fonte: 'Um Sonho de Liberdade',
  },
];

// dia do ano → a mesma frase para todo mundo, o dia inteiro
export const fraseDoDia = (date = new Date()) => {
  const inicio = new Date(date.getFullYear(), 0, 0);
  const dia = Math.floor((date - inicio) / 86400000);
  return FRASES[dia % FRASES.length];
};
